// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"fe844a47","124":"b1b79cac","185":"84ba865d","619":"430cbc61","667":"6b23b9b7","697":"25f95955","779":"14237aa9","971":"05c57050","990":"1a590d4e"}[chunkId] + ".chunk.js";
};